<section
  class="main_container bannerComponent rs-section rsb"
  #bannerRoot
  [class.rsb--hero]="hero"
  [ngStyle]="getUrl(BannerData)"
>
  <!-- ambient decoration: same blob / dot / ring language as the home hero -->
  <div class="rs-deco" aria-hidden="true">
    <span class="rs-blob rs-blob--purple rs-blob--tl rsb-drift" style="--d: 30"></span>
    <span class="rs-blob rs-blob--pink rs-blob--tr rsb-drift" style="--d: 24"></span>
    <span class="rs-blob rs-blob--indigo rs-blob--br rsb-drift" style="--d: 28"></span>
    <span class="rs-dots rs-dots--a"></span>
    <span class="rs-dots rs-dots--pink rs-dots--b"></span>
    <span class="rs-ring rs-ring--a"></span>
    <span class="rs-ring rs-ring--b"></span>
    <span class="rs-spark" style="--sx: 22%; --sy: 18%; --sd: 0s"></span>
    <span class="rs-spark" style="--sx: 68%; --sy: 12%; --sd: 1.4s"></span>
    <span class="rs-spark" style="--sx: 48%; --sy: 76%; --sd: 2.6s"></span>
  </div>

  <!-- ==================================================================== -->
  <!-- HERO — premium split layout, shown on every service page             -->
  <!-- ==================================================================== -->
  <div class="rsb-hero" *ngIf="hero">
    <div class="rs-shell rs-shell--wide rsb-hero__inner">
      <div class="rsb-hero__grid">

        <!-- ------------------------------------------------ left: copy ---- -->
        <div class="rsb-hero__copy">
          <span class="rsb-hero__eyebrow">{{ hero.eyebrow }}</span>

          <h1 class="rsb-hero__title">
            {{ hero.title }} <span class="rsb-grad">{{ hero.titleGrad }}</span>
          </h1>

          <p class="rsb-hero__lede">{{ hero.lede }}</p>

          <!-- capability badges — one row of four, as in the reference -->
          <ul class="rsb-pills" aria-label="What's included">
            <li class="rsb-pill" *ngFor="let pill of hero.pills">
              <span class="rsb-pill__ico" aria-hidden="true">
                <svg viewBox="0 0 24 24" fill="none" [attr.data-icon]="pill.icon">
                  <ng-container [ngSwitch]="pill.icon">
                    <ng-container *ngSwitchCase="'grid'">
                      <path d="M4 4h7v7H4zM13 4h7v7h-7zM4 13h7v7H4zM13 13h7v7h-7z"
                        stroke="currentColor" stroke-width="1.8" stroke-linejoin="round" />
                    </ng-container>
                    <ng-container *ngSwitchCase="'search'">
                      <circle cx="11" cy="11" r="6.5" stroke="currentColor" stroke-width="1.9" />
                      <path d="M16 16l4.5 4.5" stroke="currentColor" stroke-width="1.9"
                        stroke-linecap="round" />
                    </ng-container>
                    <ng-container *ngSwitchCase="'bolt'">
                      <path d="M13 2.5L5.5 13.5H11l-1 8 8-11.5H12l1-7.5z" stroke="currentColor"
                        stroke-width="1.8" stroke-linejoin="round" />
                    </ng-container>
                    <ng-container *ngSwitchCase="'mobile'">
                      <rect x="7" y="2.5" width="10" height="19" rx="2.5" stroke="currentColor"
                        stroke-width="1.8" />
                      <path d="M11 18.5h2" stroke="currentColor" stroke-width="1.8"
                        stroke-linecap="round" />
                    </ng-container>
                    <ng-container *ngSwitchCase="'shield'">
                      <path d="M12 3l7 3.5V12c0 4.3-2.9 7.9-7 9-4.1-1.1-7-4.7-7-9V6.5L12 3z"
                        stroke="currentColor" stroke-width="1.8" stroke-linejoin="round" />
                    </ng-container>
                    <ng-container *ngSwitchCase="'palette'">
                      <path d="M12 20a8 8 0 110-16c4.4 0 8 3.1 8 7 0 2.5-2 4-4.5 4H14a1.6 1.6 0 00-1.1 2.7A1.6 1.6 0 0112 20z"
                        stroke="currentColor" stroke-width="1.8" stroke-linejoin="round" />
                      <circle cx="8.5" cy="10.5" r="1.2" fill="currentColor" />
                    </ng-container>
                    <ng-container *ngSwitchCase="'code'">
                      <path d="M9 8l-4.5 4L9 16m6-8l4.5 4L15 16" stroke="currentColor"
                        stroke-width="1.9" stroke-linecap="round" stroke-linejoin="round" />
                    </ng-container>
                    <ng-container *ngSwitchCase="'chart'">
                      <path d="M4 19V10m5 9V5m5 14v-7m5 7V8" stroke="currentColor" stroke-width="2"
                        stroke-linecap="round" />
                    </ng-container>
                    <ng-container *ngSwitchCase="'cloud'">
                      <path d="M7 17.5h9.5a3.5 3.5 0 100-7 5 5 0 00-9.6 1.3A3 3 0 007 17.5z"
                        stroke="currentColor" stroke-width="1.8" stroke-linejoin="round" />
                    </ng-container>
                    <ng-container *ngSwitchCase="'megaphone'">
                      <path d="M4 10.5v3l11 4.5V6l-11 4.5zM7 14.5V19h3" stroke="currentColor"
                        stroke-width="1.8" stroke-linejoin="round" />
                    </ng-container>
                    <ng-container *ngSwitchCase="'video'">
                      <rect x="3" y="6.5" width="12" height="11" rx="2.4" stroke="currentColor"
                        stroke-width="1.8" />
                      <path d="M15 11l6-3v8l-6-3z" stroke="currentColor" stroke-width="1.8"
                        stroke-linejoin="round" />
                    </ng-container>
                    <ng-container *ngSwitchCase="'mail'">
                      <path d="M4 7h16v10H4zM4 7l8 6 8-6" stroke="currentColor" stroke-width="1.8"
                        stroke-linecap="round" stroke-linejoin="round" />
                    </ng-container>
                    <ng-container *ngSwitchCase="'card'">
                      <rect x="3" y="6" width="18" height="12" rx="2.4" stroke="currentColor"
                        stroke-width="1.8" />
                      <path d="M3 10.5h18" stroke="currentColor" stroke-width="1.8" />
                    </ng-container>
                    <ng-container *ngSwitchCase="'cog'">
                      <circle cx="12" cy="12" r="3" stroke="currentColor" stroke-width="1.8" />
                      <path d="M12 3.5v2.2M12 18.3v2.2M4.6 7.8l1.9 1.1M17.5 15.1l1.9 1.1M4.6 16.2l1.9-1.1M17.5 8.9l1.9-1.1"
                        stroke="currentColor" stroke-width="1.8" stroke-linecap="round" />
                    </ng-container>
                    <ng-container *ngSwitchCase="'ai'">
                      <path d="M12 3l1.7 5L19 9.7l-5.3 1.6L12 16.5l-1.7-5.2L5 9.7l5.3-1.7L12 3z"
                        stroke="currentColor" stroke-width="1.8" stroke-linejoin="round" />
                    </ng-container>
                    <ng-container *ngSwitchDefault>
                      <circle cx="9" cy="8.5" r="3" stroke="currentColor" stroke-width="1.8" />
                      <path d="M3.5 19c0-3 2.5-5 5.5-5s5.5 2 5.5 5M16 7.5a3 3 0 010 6"
                        stroke="currentColor" stroke-width="1.8" stroke-linecap="round" />
                    </ng-container>
                  </ng-container>
                </svg>
              </span>
              <span class="rsb-pill__tx">
                <b>{{ pill.label }}</b>
                <small>{{ pill.sub }}</small>
              </span>
            </li>
          </ul>
        </div>

        <!-- ------------------------------------- right: device mockups ---- -->
        <div class="rsb-hero__visual" aria-hidden="true">
          <div class="rsb-stage">
            <span class="rsb-stage__glow"></span>

            <!-- desktop monitor showing the service artwork -->
            <div class="rsb-stage__monitor" style="--d: 5">
              <div class="rsb-monitor">
                <span class="rsb-monitor__bar"><i></i><i></i><i></i></span>
                <div class="rsb-monitor__screen">
                  <img loading="lazy" class="bannerimg" src="{{ BannerData?.bannerImg?.banner }}"
                    alt="" />
                  <span class="rsb-monitor__scrim"></span>
                </div>
              </div>
              <span class="rsb-monitor__stand"></span>
              <span class="rsb-monitor__base"></span>
            </div>

            <!-- phone -->
            <div class="rsb-stage__phone" style="--d: 14">
              <span class="rsb-phone__notch"></span>
              <div class="rsb-phone__screen">
                <span class="rsb-phone__hero"></span>
                <span class="rsb-row"></span>
                <span class="rsb-row rsb-row--short"></span>
                <div class="rsb-phone__chart">
                  <span style="--h: 46%"></span>
                  <span style="--h: 74%"></span>
                  <span style="--h: 58%"></span>
                  <span style="--h: 92%"></span>
                </div>
                <span class="rsb-phone__cta"></span>
              </div>
            </div>

            <!-- desk props, drawn in CSS to match the reference scene -->
            <span class="rsb-desk" style="--d: 8">
              <span class="rsb-desk__keyboard"></span>
              <span class="rsb-desk__mouse"></span>
            </span>

            <span class="rsb-plant" style="--d: 10">
              <span class="rsb-plant__leaf rsb-plant__leaf--l"></span>
              <span class="rsb-plant__leaf rsb-plant__leaf--c"></span>
              <span class="rsb-plant__leaf rsb-plant__leaf--r"></span>
              <span class="rsb-plant__pot"></span>
            </span>
          </div>

          <!-- stat card -->
          <ul class="rsb-stats">
            <li class="rsb-stat" *ngFor="let stat of heroStats">
              <span class="rsb-stat__ico">
                <svg viewBox="0 0 24 24" fill="none">
                  <ng-container [ngSwitch]="stat.icon">
                    <ng-container *ngSwitchCase="'bolt'">
                      <path d="M13 2.5L5.5 13.5H11l-1 8 8-11.5H12l1-7.5z" stroke="currentColor"
                        stroke-width="1.8" stroke-linejoin="round" />
                    </ng-container>
                    <ng-container *ngSwitchCase="'chart'">
                      <path d="M4 17l5-5 4 3 7-8" stroke="currentColor" stroke-width="2.2"
                        stroke-linecap="round" stroke-linejoin="round" />
                    </ng-container>
                    <ng-container *ngSwitchDefault>
                      <path d="M12 3l7 3.5V12c0 4.3-2.9 7.9-7 9-4.1-1.1-7-4.7-7-9V6.5L12 3z"
                        stroke="currentColor" stroke-width="1.8" stroke-linejoin="round" />
                    </ng-container>
                  </ng-container>
                </svg>
              </span>
              <span class="rsb-stat__tx">
                <b>{{ stat.value }}</b>
                <small>{{ stat.label }}</small>
              </span>
            </li>
          </ul>
        </div>
      </div>
    </div>

    <!-- ------------------------------------------- curved pink divider ---- -->
    <!-- Two stacked curves: the tinted shape sits behind a white one, so the
         visible band is a crescent — thick at the left, tapering to the right,
         exactly the sweep in the reference. -->
    <svg class="rsb-wave" viewBox="0 0 1440 200" preserveAspectRatio="none" aria-hidden="true">
      <defs>
        <linearGradient id="rsbWaveGrad" x1="0" y1="1" x2="1" y2="0">
          <stop offset="0%" stop-color="#ff2d95" />
          <stop offset="46%" stop-color="#d94ce0" />
          <stop offset="100%" stop-color="#b14eff" stop-opacity=".55" />
        </linearGradient>
        <linearGradient id="rsbWaveSoft" x1="0" y1="1" x2="1" y2="0">
          <stop offset="0%" stop-color="#b14eff" stop-opacity=".22" />
          <stop offset="100%" stop-color="#6c63ff" stop-opacity=".08" />
        </linearGradient>
      </defs>
      <path class="rsb-wave__soft" fill="url(#rsbWaveSoft)"
        d="M0 30C380 150 940 178 1440 120V200H0Z" />
      <path class="rsb-wave__tint" fill="url(#rsbWaveGrad)"
        d="M0 64C380 172 940 194 1440 140V200H0Z" />
      <!-- the white curve converges on the tinted one toward the right, so the
           visible band tapers from ~50px at the left edge down to a hairline -->
      <path class="rsb-wave__top" fill="#ffffff"
        d="M0 116C380 206 940 212 1440 158V200H0Z" />
    </svg>
  </div>

  <!-- ==================================================================== -->
  <!-- FORM — floating glass card                                            -->
  <!-- ==================================================================== -->
  <div class="rs-shell rsb__shell">
    <div class="adjustment_container rsb__grid" [class.rsb__grid--stacked]="hero">

      <!-- the original visual column, kept for pages without a hero config -->
      <div class="rsb__lead" *ngIf="!hero">
        <div class="rsb__stage">
          <span class="rsb__glow" aria-hidden="true"></span>
          <span class="rsb__orbit" aria-hidden="true"></span>
          <div class="rsb__shot">
            <img
              loading="lazy"
              class="bannerimg"
              src="{{ BannerData?.bannerImg?.banner }}"
              alt="seo"
            />
          </div>
        </div>

        <div class="carousal_container rsb__ticker">
          <ngx-slick-carousel
            #slickModal="slick-carousel"
            [config]="slideConfigmsg"
          >
            <div
              ngxSlickItem
              *ngFor="let txt of BannerData.bannerTXT"
              class="slide"
            >
              <div class="content rsb__slide">
                <p class="description rsb__claim">{{ txt.title }}</p>
              </div>
            </div>
          </ngx-slick-carousel>
        </div>
      </div>

      <!-- ------------------------------------------------------------ form -->
      <div class="pull-right rsb__aside" [class.rsb__aside--wide]="hero">
        <app-consult-form
          [form]="formData"
          [sending]="isSubmitting"
          [compact]="!hero"
          (send)="submit()"
        ></app-consult-form>
      </div>
    </div>
  </div>
</section>
